export default __webpack_public_path__ + "static/media/ic_selector_dropdowns.aaf0b8f0.svg";